import { useSeo } from '@/hooks/useSeo';
import { comics } from '@/mocks/comics';
import Hero from './components/Hero';
import LatestUpdates from './components/LatestUpdates';
import HotRanking from './components/HotRanking';
import CategoryBrowse from './components/CategoryBrowse';
import EditorPicks from './components/EditorPicks';
import CtaBanner from './components/CtaBanner';
import HomeFaq from './components/HomeFaq';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=stylized%20webtoon%20manga%20collage%20hero%20banner%20illustration%2C%20cheerful%20diverse%20comic%20characters%20floating%20in%20dreamy%20fluffy%20clouds%2C%20warm%20orange%20caramel%20cream%20gradient%20sky%2C%20floating%20books%20and%20heart%20shapes%2C%20clean%20flat%20vector%20art%2C%20cozy%20inviting%20atmosphere%2C%20wide%20banner%20composition%2C%20no%20text&width=1600&height=900&seq=hero-2026-pudding&orientation=landscape';

const featured = comics[0];

const faqJsonLd = [
  {
    '@type': 'Question',
    name: '在布丁漫画网阅读漫画需要付费吗？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '完全免费。布丁漫画网坚持全站免费在线阅读，《寄宿日记》等所有作品均无需付费、无需注册即可畅读全集中文版本。',
    },
  },
  {
    '@type': 'Question',
    name: '《寄宿日记》漫画多久更新一次？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '《寄宿日记》每周固定更新，通常在周五晚更新新章节，遇节假日会加更。您可以在作品页查看最近更新时间。',
    },
  },
  {
    '@type': 'Question',
    name: '手机和电脑都能看漫画吗？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '可以。布丁漫画网采用响应式设计，手机、平板、电脑浏览器均可直接访问，无需下载任何应用即可流畅阅读。',
    },
  },
  {
    '@type': 'Question',
    name: '如何快速找到想看的漫画？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '您可以通过顶部搜索框直接输入漫画名称，也可以进入全部漫画页面按恋爱、校园、日常等分类浏览，或参考热门排行榜选择。',
    },
  },
];

export default function Home() {
  useSeo({
    title: '《寄宿日记》漫画-在线免费阅读漫画-布丁漫画网',
    description:
      '《寄宿日记》漫画,在线免费阅读,布丁漫画网 在布丁漫画网在线免费阅读《寄宿日记》漫画，畅读全集中文版本，无需付费即可体验流畅的在线浏览和丰富故事。',
    keywords: '寄宿日记,漫画,在线免费阅读,布丁漫画网,校园漫画,恋爱漫画',
    path: '/',
    ogImage: HERO_IMAGE,
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '布丁漫画网',
        url: `${window.location.origin}${__BASE_PATH__ || ''}`,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${window.location.origin}${__BASE_PATH__ || ''}/category?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '《寄宿日记》漫画-在线免费阅读漫画-布丁漫画网',
        description:
          '在布丁漫画网在线免费阅读《寄宿日记》漫画，畅读全集中文版本，无需付费即可体验流畅的在线浏览和丰富故事。',
        inLanguage: 'zh-CN',
        primaryImageOfPage: HERO_IMAGE,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqJsonLd,
      },
    ],
  });

  return (
    <div>
      <Hero />
      <LatestUpdates />
      <HotRanking />
      <CategoryBrowse />
      <EditorPicks />
      <CtaBanner />
      <HomeFaq />
      <section className="mx-auto max-w-7xl px-4 pb-12 pt-2 md:px-6 md:pb-16">
        <p className="text-center text-xs text-foreground-500">
          布丁漫画网收录《{featured.title}
          》等 1,200+ 部漫画作品，全部支持在线免费阅读，畅读全集中文版本。
        </p>
      </section>
    </div>
  );
}